import React, { Component } from "react";
import { Card, Table, Switch, Tag, Modal, Input, Select, Checkbox, Radio, Dropdown, Menu, Popconfirm, Tooltip, message } from "antd";
import { PlusOutlined, DownOutlined, EditOutlined, DeleteOutlined, SendOutlined, BellOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";
import SelectUsuariosItem from "../../../../Components/SelectUsuariosItem";
import { cmmsPost } from "../cmmsComun";
import "../cmms.css";

const { Option } = Select;

// Avisos programados del CMMS (los revisa un cron cada hora): que incluye cada aviso, que dias y a
// que hora, y a quien. Se guardan al aceptar el editor (no con el boton Guardar de la pantalla).
// props: avisos, secciones (catalogo del backend), empresaId, headersToken, onCambio()

const DIAS = [
    { value: 1, corto: "Lun", label: "Lunes" },
    { value: 2, corto: "Mar", label: "Martes" },
    { value: 3, corto: "Mié", label: "Miércoles" },
    { value: 4, corto: "Jue", label: "Jueves" },
    { value: 5, corto: "Vie", label: "Viernes" },
    { value: 6, corto: "Sáb", label: "Sábado" },
    { value: 0, corto: "Dom", label: "Domingo" },
];

const PLANTILLAS = {
    coordinacion: {
        titulo: "Pendientes para coordinación",
        aviso: {
            nombre: "Pendientes para coordinación",
            dias: [1, 2, 3, 4, 5, 6],
            hora: 7,
            secciones: ["ticketsUrgentes", "ticketsSinAsignar", "atrasados", "preventivosVencidos", "contratosPorRenovar", "vueltasPorCerrar", "certificadosPorVencer", "patrones"],
            notificar: "usuarios",
        },
    },
    ingenieros: {
        titulo: "Agenda del día de cada ingeniero",
        aviso: {
            nombre: "Agenda del día",
            dias: [1, 2, 3, 4, 5],
            hora: 7,
            secciones: ["serviciosHoy", "agendaHoy", "atrasados", "ticketsUrgentes", "viajesHoy"],
            notificar: "nadie",
            ingenieros: { notificacion: true, correo: false },
        },
    },
    semanal: {
        titulo: "Resumen semanal (lunes)",
        aviso: {
            nombre: "Resumen semanal",
            dias: [1],
            hora: 8,
            secciones: ["preventivosVencidos", "contratosPorRenovar", "vueltasPorCerrar", "certificadosPorVencer", "patrones"],
            notificar: "usuarios",
        },
    },
    blanco: { titulo: "En blanco", aviso: { nombre: "", dias: [1, 2, 3, 4, 5], hora: 7, secciones: [], notificar: "usuarios" } },
};

const avisoVacio = () => ({ nombre: "", activo: true, dias: [1, 2, 3, 4, 5], hora: 7, secciones: [], notificar: "usuarios", usuariosIds: [], correos: [], ingenieros: { notificacion: false, correo: false } });

const textoDias = (dias = []) => {
    const s = [...dias].sort().join(",");
    if (s === "0,1,2,3,4,5,6") return "Todos los días";
    if (s === "1,2,3,4,5") return "Lunes a viernes";
    if (s === "1,2,3,4,5,6") return "Lunes a sábado";
    return DIAS.filter((d) => dias.includes(d.value))
        .map((d) => (dias.length === 1 ? d.label : d.corto))
        .join(", ");
};

const textoHora = (h) => `${String(h).padStart(2, "0")}:00`;

const textoDestinos = (a) =>
    [
        a.notificar === "todos" ? "Notificación a todos los usuarios" : a.notificar === "usuarios" ? `Notificación a ${a.usuariosIds?.length || 0} usuario(s)` : "",
        a.correos?.length ? `${a.correos.length} correo(s)` : "",
        a.ingenieros?.notificacion || a.ingenieros?.correo
            ? `Cada ingeniero lo suyo (${[a.ingenieros.notificacion ? "notificación" : "", a.ingenieros.correo ? "correo" : ""].filter(Boolean).join(" y ")})`
            : "",
    ]
        .filter(Boolean)
        .join(" · ") || "Nadie";

class AvisosProgramadosCMMS extends Component {
    state = { editando: null, indice: null, guardando: false, enviando: null };

    // Guarda la lista completa (los avisos del backend + el cambio).
    guardarLista = async (avisos, mensaje) => {
        this.setState({ guardando: true });
        try {
            const res = await cmmsPost(this.props, "guardarAvisosCMMS", { avisos });
            if (res.data.success !== 2) {
                message.error(res.data.message || "No se pudo guardar");
                return false;
            }
            if (mensaje) message.success(mensaje);
            this.props.onCambio();
            return true;
        } finally {
            this.setState({ guardando: false });
        }
    };

    nuevo = (clave) => this.setState({ editando: { ...avisoVacio(), ...PLANTILLAS[clave].aviso }, indice: null });

    aceptar = async () => {
        const a = this.state.editando;
        if (!String(a.nombre || "").trim()) return message.error("Escriba el nombre del aviso");
        const lista = [...(this.props.avisos || [])];
        if (this.state.indice === null) lista.push(a);
        else lista[this.state.indice] = a;
        if (await this.guardarLista(lista, "Aviso guardado")) this.setState({ editando: null, indice: null });
    };

    enviarAhora = async (aviso) => {
        this.setState({ enviando: aviso._id });
        try {
            const res = await cmmsPost(this.props, "probarAvisoCMMS", { avisoId: aviso._id });
            if (res.data.success !== 2) return message.error(res.data.message || "No se pudo enviar");
            if (!res.data.enviado) return message.info("Hoy no hay nada de lo que incluye este aviso: no se mandó nada");
            message.success(
                `"${aviso.nombre}" enviado: ${[
                    res.data.notificaciones ? `${res.data.notificaciones} notificación(es)` : "",
                    res.data.correos ? `${res.data.correos} correo(s)` : "",
                    res.data.ingenieros ? `${res.data.ingenieros} ingeniero(s) con pendientes` : "",
                ]
                    .filter(Boolean)
                    .join(", ")}`
            );
        } finally {
            this.setState({ enviando: null });
        }
    };

    cambiar = (cambios) => this.setState((s) => ({ editando: { ...s.editando, ...cambios } }));

    cambiarCorreos = (valores) => {
        const correos = valores.map((v) => String(v).trim().toLowerCase()).filter(Boolean);
        const invalidos = correos.filter((c) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c));
        if (invalidos.length) message.warning(`No es un correo válido: ${invalidos.join(", ")}`);
        this.cambiar({ correos: [...new Set(correos.filter((c) => !invalidos.includes(c)))].slice(0, 10) });
    };

    renderEditor() {
        const a = this.state.editando;
        if (!a) return null;
        const secciones = this.props.secciones || [];
        const grupo = (porIngeniero) => secciones.filter((s) => !!s.porIngeniero === porIngeniero);
        const marcar = (clave, si) => this.cambiar({ secciones: si ? [...new Set([...(a.secciones || []), clave])] : (a.secciones || []).filter((x) => x !== clave) });
        const casillas = (lista) =>
            lista.map((s) => (
                <div key={s.clave}>
                    <Checkbox checked={(a.secciones || []).includes(s.clave)} onChange={(e) => marcar(s.clave, e.target.checked)}>
                        {s.nombre}
                    </Checkbox>
                </div>
            ));
        return (
            <Modal
                className="cmms-modal"
                visible
                width={window.innerWidth > 900 ? 820 : "96%"}
                onCancel={() => this.setState({ editando: null, indice: null })}
                onOk={this.aceptar}
                okText="Guardar aviso"
                cancelText="Cancelar"
                confirmLoading={this.state.guardando}
                title={
                    <div className="cmms-modal-titulo">
                        <BellOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">{this.state.indice === null ? "Nuevo aviso" : "Editar aviso"}</div>
                            <div className="cmms-modal-subtitulo">Sólo llega si hay algo de lo que incluye. Para no saturar, mándelo sólo a quien lo necesita.</div>
                        </div>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo cmms-aviso-editor">
                    <div className="cmms-aviso-fila">
                        <div style={{ flex: 1 }}>
                            <div className="cmms-etiqueta-campo">Nombre</div>
                            <Input maxLength={80} placeholder="Ej. Agenda del día" value={a.nombre} onChange={(e) => this.cambiar({ nombre: e.target.value })} />
                        </div>
                        <div>
                            <div className="cmms-etiqueta-campo">Activo</div>
                            <Switch checked={a.activo !== false} onChange={(activo) => this.cambiar({ activo })} />
                        </div>
                    </div>

                    <div className="cmms-aviso-seccion">Cuándo</div>
                    <div className="cmms-aviso-fila">
                        <Checkbox.Group value={a.dias} onChange={(dias) => this.cambiar({ dias })} options={DIAS.map((d) => ({ label: d.corto, value: d.value }))} />
                        <Select style={{ width: 110 }} value={a.hora} onChange={(hora) => this.cambiar({ hora })}>
                            {Array.from({ length: 24 }, (_, h) => (
                                <Option key={h} value={h}>
                                    {textoHora(h)}
                                </Option>
                            ))}
                        </Select>
                        <span className="cmms-ayuda" style={{ margin: 0 }}>
                            Hora de México
                        </span>
                    </div>

                    <div className="cmms-aviso-seccion">Qué incluye</div>
                    <div className="cmms-aviso-columnas">
                        <div>
                            <div className="cmms-etiqueta-campo">
                                Del día{" "}
                                <Tooltip title="En el aviso a cada ingeniero se filtran a lo suyo y lo que no tiene ingeniero.">
                                    <Tag color="blue">por ingeniero</Tag>
                                </Tooltip>
                            </div>
                            {casillas(grupo(true))}
                        </div>
                        <div>
                            <div className="cmms-etiqueta-campo">De toda la empresa</div>
                            {casillas(grupo(false))}
                        </div>
                    </div>

                    <div className="cmms-aviso-seccion">Para quién</div>
                    <Radio.Group value={a.notificar} onChange={(e) => this.cambiar({ notificar: e.target.value })}>
                        <Radio value="usuarios">Notificación sólo a estos usuarios</Radio>
                        <Radio value="todos">Notificación a todos los usuarios</Radio>
                        <Radio value="nadie">Sin notificación general</Radio>
                    </Radio.Group>
                    {a.notificar === "usuarios" && (
                        <div style={{ marginTop: 8 }}>
                            <SelectUsuariosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                placeholder="Elija los usuarios"
                                value={(a.usuariosIds || []).map(String)}
                                onChange={(usuariosIds) => this.cambiar({ usuariosIds })}
                            />
                        </div>
                    )}
                    <div style={{ marginTop: 10 }}>
                        <div className="cmms-etiqueta-campo">También por correo a</div>
                        <Select mode="tags" style={{ width: "100%" }} value={a.correos || []} onChange={this.cambiarCorreos} placeholder="coordinacion@empresa.com" open={false} tokenSeparators={[",", ";", " "]} />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <div className="cmms-etiqueta-campo">A cada ingeniero, lo suyo</div>
                        <Checkbox checked={!!a.ingenieros?.notificacion} onChange={(e) => this.cambiar({ ingenieros: { ...a.ingenieros, notificacion: e.target.checked } })}>
                            Notificación
                        </Checkbox>
                        <Checkbox checked={!!a.ingenieros?.correo} onChange={(e) => this.cambiar({ ingenieros: { ...a.ingenieros, correo: e.target.checked } })}>
                            Correo
                        </Checkbox>
                        <div className="cmms-ayuda" style={{ margin: "4px 0 0" }}>
                            Sólo los ingenieros ligados a su usuario en Ingenieros (arriba). A cada uno le llega lo suyo y lo que no tiene ingeniero; si no tiene nada, no le llega.
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }

    render() {
        const avisos = this.props.avisos || [];
        return (
            <Card
                title="Avisos programados"
                style={{ marginTop: 10 }}
                extra={
                    <Dropdown
                        trigger={["click"]}
                        placement="bottomRight"
                        overlay={
                            <Menu onClick={({ key }) => this.nuevo(key)}>
                                {Object.entries(PLANTILLAS).map(([clave, p]) => (
                                    <Menu.Item key={clave}>{p.titulo}</Menu.Item>
                                ))}
                            </Menu>
                        }
                    >
                        <ButtonItem cyan lessTime icon={<PlusOutlined />}>
                            Agregar aviso <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
                        </ButtonItem>
                    </Dropdown>
                }
            >
                <div className="cmms-ayuda">
                    Cada hora se revisa qué avisos tocan. Un aviso sólo llega si hoy hay algo de lo que incluye, y sale una vez al día. Lo que incluyen es lo mismo que se ve en CMMS › Inicio.
                </div>
                <Table
                    size="small"
                    rowKey={(a) => String(a._id || a.nombre)}
                    pagination={false}
                    dataSource={avisos}
                    locale={{ emptyText: "Sin avisos programados: no se manda nada" }}
                    columns={[
                        {
                            title: "Activo",
                            width: 70,
                            render: (a, _, i) => (
                                <Switch
                                    size="small"
                                    checked={a.activo !== false}
                                    loading={this.state.guardando}
                                    onChange={(activo) => this.guardarLista(avisos.map((x, j) => (j === i ? { ...x, activo } : x)), activo ? "Aviso activado" : "Aviso apagado")}
                                />
                            ),
                        },
                        {
                            title: "Aviso",
                            render: (a) => (
                                <span>
                                    <b>{a.nombre}</b>
                                    <div className="cmms-agenda-item-sub">
                                        {(a.secciones || [])
                                            .map((c) => (this.props.secciones || []).find((s) => s.clave === c)?.nombre)
                                            .filter(Boolean)
                                            .join(" · ")}
                                    </div>
                                </span>
                            ),
                        },
                        { title: "Cuándo", width: 170, render: (a) => `${textoDias(a.dias)} · ${textoHora(a.hora)}` },
                        { title: "Para quién", width: 260, render: (a) => <span style={{ fontSize: 12 }}>{textoDestinos(a)}</span> },
                        { title: "Último envío", dataIndex: "ultimoEnvio", width: 110, render: (v) => (v ? v.split("-").reverse().join("/") : "—") },
                        {
                            title: "",
                            width: 130,
                            render: (a, _, i) => (
                                <span style={{ display: "flex", gap: 4 }}>
                                    <Tooltip title="Editar">
                                        <ButtonItem size="small" cyan lessTime icon={<EditOutlined />} onClick={() => this.setState({ editando: { ...avisoVacio(), ...a }, indice: i })} />
                                    </Tooltip>
                                    <Tooltip title="Enviar ahora (aunque no sea su día ni su hora)">
                                        <ButtonItem size="small" blanco lessTime loading={this.state.enviando === a._id} icon={<SendOutlined />} onClick={() => this.enviarAhora(a)} />
                                    </Tooltip>
                                    <Popconfirm title="¿Quitar este aviso?" okText="Sí" cancelText="No" onConfirm={() => this.guardarLista(avisos.filter((_, j) => j !== i), "Aviso quitado")}>
                                        <ButtonItem size="small" rojo lessTime icon={<DeleteOutlined />} />
                                    </Popconfirm>
                                </span>
                            ),
                        },
                    ]}
                />
                {this.renderEditor()}
            </Card>
        );
    }
}

export default AvisosProgramadosCMMS;
